module.exports = __webpack_public_path__ + "img/foot.a128f5b2.png";